import { useEffect, useState } from 'react';

import { getAllFaq } from 'utils/FaqAPI';
import { Faq } from 'types/Faq';

export default function useFaq() {
  const [faq, setFaq] = useState<Faq[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const allFaq = await getAllFaq();

      allFaq.sort((a, b) => (a.order > b.order ? 1 : -1));

      setFaq(allFaq);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  return {
    faq,
    isLoading,
  };
}
